import { graphql } from "msw";
import operations from "../data/oms/operations";

export const handlers = [
  graphql.query("projectOperations", (req, res, ctx) => {
    const { projectId } = req.variables;

    return res(
      ctx.data({
        projectOperations: operations.filter(
          /* eslint-disable */
          (operation) => operation.project.id == projectId
          /* eslint-enable */
        ),
      })
    );
  }),
];
